// eslint-disable-next-line no-restricted-imports
import AsyncStorage from '@react-native-async-storage/async-storage';

async function setItem(token, item) {
  await AsyncStorage.setItem(token, JSON.stringify(item));
}

async function getItem(token) {
  return JSON.parse(await AsyncStorage.getItem(token));
}

async function removeItem(token) {
  return await AsyncStorage.removeItem(token);
}

class AsyncStoreService {
  TOKEN_DATA = 'TokenData';
  setTokenData = async (tokenData) => setItem(this.TOKEN_DATA, tokenData);
  getTokenData = async () => getItem(this.TOKEN_DATA);
  removeTokenData = async () => removeItem(this.TOKEN_DATA);

  USER_DATA = 'UserData';
  setUserData = async (userData) => setItem(this.USER_DATA, userData);
  getUserData = async () => getItem(this.USER_DATA);
  removeUserData = async () => removeItem(this.USER_DATA);

  SEARCH_INPUT = 'SearchInput';
  setSearchInput = async (searchInput) => setItem(this.SEARCH_INPUT, searchInput);
  getSearchInput = async () => getItem(this.SEARCH_INPUT);
  removeSearchInput = async () => removeItem(this.SEARCH_INPUT);

  SABRE_TOKEN_DATA = 'SabreTokenData';
  setSabreTokenData = async (tokenData) => setItem(this.SABRE_TOKEN_DATA, tokenData);
  getSabreTokenData = async () => getItem(this.SABRE_TOKEN_DATA);
  removeSabreTokenData = async () => removeItem(this.SABRE_TOKEN_DATA);

  USER_NAME = 'UserName';
  setUserName = async (userName) => setItem(this.USER_NAME, userName);
  getUserName = async () => getItem(this.USER_NAME);
  removeUserName = async () => removeItem(this.USER_NAME);
}

export default new AsyncStoreService();
